// 不足两位数前面加0
export const zeroFill = (num) => {
  if (!num) return;
  return num < 10 ? "0" + num : num;
};

// 时间戳转换为日期
export const formatDate = (date, format = "yyyy-MM-dd hh:mm:ss") => {
  if (!date) return "";

  let type = typeof date;
  if (type != "string" && type != "number") return date;

  date = new Date(date);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  let d = date.getDate();
  let h = date.getHours();
  let m1 = date.getMinutes();
  let s = date.getSeconds();
  m = m < 10 ? "0" + m : m;
  d = d < 10 ? "0" + d : d;
  h = h < 10 ? "0" + h : h;
  m1 = m1 < 10 ? "0" + m1 : m1;
  s = s < 10 ? "0" + s : s;

  return (format = format
    .replace("yyyy", y)
    .replace("MM", m)
    .replace("dd", d)
    .replace("hh", h)
    .replace("mm", m1)
    .replace("ss", s));
};

// 日期转时间戳 精确到秒
// Date.parse(data) 之精确到秒 毫秒用000代替
export const formatTimestamp = (data) => {
  return (
    Date.parse(new Date(data)) ||
    Date.parse(new Date(`${data.replace(/-/g, "/")}`))
  );
};

// 日期转时间戳 精确到毫秒
// data.getTime()、data.getValueOf()会精确到毫秒
export const formatTimestampMillS = (param) => {
  return param.getTime() || param.replace(/-/g, "/").getTime();
};

// 强制保留小数点后位数
export const formatFloat = (param, num = 2) => {
  if (!param) return param;
  return Math.round((param * Math.pow(10, num)) / Math.pow(10, num));
};

// 验证手机号
export const telReg = (param) => {
  if (!param) return "";
  let reg = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/;
  return reg.test(param);
};

// 验证邮箱
export const emailReg = (param) => {
  if (!param) return "";
  let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  return reg.test(param);
};

// 获取url？后的参数
// url: 可以是完整的url，也可以是?id = 1的形式
// name: 指定返回特定的参数，不传默认以键值对的形式返回全部的参数
export const getUrlParams = (url, name) => {
  if (!url) return "";
  let obj = {};
  let paramsArr = url.split("?")[1];
  if (paramsArr.length <= 0) return "";
  paramsArr = paramsArr.split("&");
  for (let param of paramsArr) {
    let paramArr = param.split("=");
    let key = paramArr[0];
    let val = paramArr[1];
    console.log(key, val);
    obj[key] = val;
  }
  return name ? obj[name] : obj;
};

// 获取地址栏参数 正则
export const getQueryString = (url, name) => {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  url = url.split("?")[1];
  let r = url.match(reg);
  if (r == null) return null;
  let params = unescape(r[2]);
  return name ? params[name] : params;
};

// 部分隐藏处理
// str 要处理的字符串
// beforeNum 前面保留几位 默认为 3
// afterNum 后面保留几位 默认为 4
// flag 中加要替换的字符 默认为*
// fill兼容chrome
export const plusXingStr = (str, beforeNum = 3, afterNum = 4, flag = "*") => {
  if (!str) return "";
  afterNum = str.length - afterNum;
  let type = typeof str;
  str = type == "string" ? str : str.toString();
  let arr = str.split("");
  arr.fill(flag, beforeNum, afterNum);
  return arr.join("");
};

// str 要处理的字符串
// beforeNum 前面保留几位 默认为 3
// afterNum 后面保留几位 默认为 4
// flag 中加要替换的字符 默认为*
export const plusXing = (str, beforeNum = 3, afterNum = 4, flag = "*") => {
  if (!str) return "";
  let i = beforeNum;
  let len = str.length - afterNum;
  let type = typeof str;
  str = type == "string" ? str : str.toString();
  let arr = str.split("");
  console.log("plusXing::", arr);
  for (i; i < len; i++) {
    arr[i] = flag;
  }
  return arr.join("");
};

// 提取数组对象中的某个键到数组
export const objectToArr = (params, key) => {
  if (typeof params != "object") return "";

  let obj = {};
  obj[key] = [];

  for (let item of params) {
    if (item.hasOwnProperty(key)) {
      let val = item[key];
      val && obj[key].push(val);
    }
  }

  return obj;
};

//标准格式日期转为RFC3339
export const getRFC3339 =()=>{
  let y = new Date().getFullYear()
  let m = new Date().getMonth()+1<10?'0'+(new Date().getMonth()+1):(new Date().getMonth()+1)
  let d = new Date().getDate()<10?'0'+new Date().getDate():new Date().getDate()
  let hh = new Date().getHours()<10?'0'+new Date().getHours():new Date().getHours();            
  let mm = new Date().getMinutes()<10?'0'+new Date().getMinutes():new Date().getMinutes()
  let ss = new Date().getSeconds()<10?'0'+new Date().getSeconds():new Date().getSeconds()
  let endDate = y +'-' + m + '-' + d + ' ' + hh + ':' + mm + ':' + ss
  endDate = endDate.replace(/\s+/g, 'T')+'+08:00'
  return endDate;
}
